import { Component } from "@angular/core";
import { IonicPage, NavParams } from "ionic-angular";
import { Api } from "../../services/api";

@IonicPage({
  segment: "reseller-order-list",
})
@Component({
  selector: "page-reseller-order-list",
  templateUrl: "reseller-order-list.html",
})
export class ResellerOrderListPage {
  constructor(private api: Api) {}

  data = { list: null };

  private refreshData() {
    this.api
      .resellerPaymentGetResellerOrderList()
      .then((resp) => (this.data.list = resp.list));
  }

  ionViewDidEnter() {
    this.refreshData();
  }

  open(item) {
    window.location.hash = "/reseller-order-detail/" + item.id;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reseller-order-list/reseller-order-list.ts